import React from 'react';
import ReactDOM from 'react-dom';
import SearchBar from './components/SearchBar';

const element = typeof document !== 'undefined' && document.querySelector('#SearchBar-component');

if (element) {
    const props = window.initialData.SearchBar;

    ReactDOM.render(
        <SearchBar {...props}/>,
        element
    );
}

export default SearchBar;
